import React from 'react';
import { useRouter } from 'next/navigation';
import MobileCityPicker from '@/components/job-title/city-picker/MobileCityPicker';
import CitySearchOptions from '@/components/form/inputs/CitySearchOptions';
import { CityOption } from '@/context/city';
import { CityContext } from '@/context/create-context';
import { CascadeOption } from '@/components/form/inputs/CascadeSelect';

const SearchArea = (props: { existCities: CascadeOption[] }) => {
  const { existCities } = props;
  const { name: cityName } = React.useContext(CityContext);
  const [cityPickerOpen, setCityPickerOpen] = React.useState(false);
  const router = useRouter();

  const handleMobileSearch = () => setCityPickerOpen(true);

  const handleClick = (val: CityOption) => {
    const { pinyin } = val;
    if (pinyin) {
      router.push(`/${pinyin}/`);
    }
  };

  const cityValue = React.useMemo(() => {
    const findValue = cityName
      ? existCities
          ?.map((item) => {
            if ('children' in item) {
              const childValue = item['children']?.find((cItem) => {
                const { name } = cItem;
                return name === cityName || name.slice(0, -1) === cityName;
              });
              if (childValue) {
                return childValue;
              }
            }
          })
          .filter(Boolean)
      : undefined;
    return findValue && findValue?.length > 0
      ? findValue[0]
      : { name: '', id: '', pinyin: '' };
  }, [cityName]);

  return (
    <>
      <div className="w-full items-center mb-16 pb-1.5">
        <CitySearchOptions
          options={existCities}
          value={cityValue}
          onChange={handleClick}
          optionsClassName="!bg-white w-1/3"
          handleMobileSearch={handleMobileSearch}
          isHalfWidth={true}
        />
      </div>
      <MobileCityPicker
        value={cityValue}
        options={existCities}
        cityPickerOpen={cityPickerOpen}
        onCitySelect={handleClick}
        onClose={() => setCityPickerOpen(false)}
        showNationWide={false}
      />
    </>
  );
};

export default SearchArea;
